import React from 'react'

import { Image, useTheme } from '@gousto-internal/citrus-react'
import type { ImageProps } from '@gousto-internal/citrus-react'

import {
  buildContentstackImageUrl,
  buildContentstackSrcSet,
  getContentstackImageWidths,
} from './contentstackImageUtils'

export interface ContentstackImageProps extends Omit<ImageProps, 'src' | 'srcSet'> {
  src: string
  sizes: string
  widths?: number[]
  mobileSrc?: string
  mobileMedia?: string
}

export const ContentstackImage = ({
  sizes,
  src,
  widths,
  mobileSrc,
  mobileMedia,
  ...imageProps
}: ContentstackImageProps) => {
  const { theme } = useTheme()
  const responsiveWidths = widths ?? getContentstackImageWidths(theme.tokens.breakpoints)
  const fallbackWidth = responsiveWidths[responsiveWidths.length - 1]
  const resolvedMobileMedia = mobileMedia ?? `(max-width: ${theme.tokens.breakpoints[0]})`
  const desktopImage = (
    <Image
      {...imageProps}
      sizes={sizes}
      src={buildContentstackImageUrl(src, { width: fallbackWidth })}
      srcSet={buildContentstackSrcSet(src, responsiveWidths)}
    />
  )

  if (!mobileSrc) {
    return desktopImage
  }

  return (
    <picture>
      <source
        srcSet={buildContentstackSrcSet(mobileSrc, responsiveWidths)}
        media={resolvedMobileMedia}
        sizes={sizes}
      />
      {desktopImage}
    </picture>
  )
}
